export const roles = {
  client: "Cliente",
  itSupport: "IT Support",
  director: "Director de proyecto",
  auditor: "Auditor",
  teamField: "Equipo de campo",
  teamOffice: "Equipo de oficina",
  other: "Other",
};
